import React from 'react'

const ACCENT_BTN = 'rounded-xl bg-[#00d4aa] px-5 py-2.5 text-sm font-semibold text-[#0a0a0f] transition hover:bg-[#1ae0b8] active:scale-[0.98] disabled:opacity-50'

export function PrimaryButton({ children, className = '', ...props }) {
  return (
    <button type="button" className={`${ACCENT_BTN} ${className}`} {...props}>
      {children}
    </button>
  )
}

export function SecondaryButton({ children, className = '', ...props }) {
  return (
    <button
      type="button"
      className={`rounded-xl border border-white/20 bg-white/5 px-5 py-2.5 text-sm font-medium text-white/90 transition hover:border-[#00d4aa]/40 hover:bg-[#00d4aa]/10 hover:text-white disabled:opacity-50 ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}

export function DangerButton({ children, className = '', ...props }) {
  return (
    <button
      type="button"
      className={`rounded-xl border border-red-500/30 bg-red-500/10 px-5 py-2.5 text-sm font-medium text-red-300 transition hover:bg-red-500/20 disabled:opacity-50 ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
